import moment from "moment";
import { FORM_ACTIONS } from "./types";
import { portalService } from "../../BookingPortal/services";
import { loading } from "../../BookingPortal/actions/";
import * as actions from "../../Layout/actions";
import { deepGet, getResponseErrorMessage, formatMoment } from "../../../utils";

export const updatePersonalDetail = (prop, value) => {
  return {
    type: FORM_ACTIONS.UPDATE_PERSONAL_DETAIL,
    payload: { prop, value }
  };
};

export const showError = (prop, errorMessage) => {
  return {
    type: FORM_ACTIONS.SHOW_ERROR_MESSAGE,
    payload: { prop, errorMessage }
  };
};

export const toggleVerifyDrawer = open => {
  return {
    type: FORM_ACTIONS.TOGGLE_VERIFY_DRAWER,
    payload: { open }
  };
};

export const requestVerificationCode = () => async (dispatch, getState) => {
  const { mobile, smsCount, isVerifyDrawerOpen } = getState().personalDetail;
  dispatch(loading(true));
  await portalService.requestVerificationCode({
    mobileNumber: mobile,
    smsCount
  });
  dispatch(loading(false));

  if (!isVerifyDrawerOpen) dispatch(toggleVerifyDrawer(true));
};

export const verifyCode = code => async (dispatch, getState) => {
  try {
    await portalService.verifyCode({ verificationCode: code });
    return true;
  } catch (e) {
    return false;
  }
};

export const submitBooking = (
  code = "",
  useRecaptcha = false,
  recaptchaToken = ""
) => async (dispatch, getState) => {
  const isRequestingCode = code === "";
  const {
    appointment,
    personalDetail,
    config,
    dataSource,
    waitingList
  } = getState();
  const {
    specialtyType,
    appointmentType,
    practitioner,
    location,
    timezone,
    appointmentDateTime
  } = appointment;

  const {
    firstName,
    lastName,
    email,
    mobile,
    dateOfBirth,
    comments,
    healthFund,
    cardNumber,
    cardPosition,
    customFields,
    smsCount
  } = personalDetail;
  const { specialtyTypes, practitioners, locations, positions } = dataSource;
  const practitionerDetail = practitioners.find(
    p => p.practitionerId === practitioner
  );

  const locationDetail = locations.find(l => l.locationId === location);

  const isPhoneConsult = config.siteConsultTypes.some(
    type => type.siteId === location && type.consultType === 1
  );
  const appointmentTypes = dataSource.appointmentTypes || [];
  const isTelehealthAppointment = !!deepGet(
    appointmentTypes.find(a => a.appointmentTypeId === appointmentType),
    ["isTeleHealthEnabled"], 
    false
  )
  const appointmentParams = {
    startDateTime: deepGet(appointmentDateTime, ["startDateTime"]),
    endDateTime: deepGet(appointmentDateTime, ["endDateTime"]),
    practitioner: {
      practitionerId: practitioner === "ANY" ? "" : practitioner
    },
    locationId: location === "ANY" ? "" : location,
    timezoneId: timezone,
    appointmentTypeId: appointmentType,
    notes: `${comments || ""} ${
      isPhoneConsult ? "*This appointment is a phone consultation*" : ""
    }`,
    smsVerifyCode: code,
    smsCount: smsCount,
    bookingDetails: config.confirmationText
      .replace(
        "#SpecialtyName#",
        deepGet(specialtyTypes.find(s => s.specialtyTypeId === specialtyType), [
          "name"
        ])
      )
      .replace(
        "#Specialist#",
        practitioner === "ANY"
          ? "ANY"
          : practitionerDetail
            ? `${practitionerDetail.firstName} ${practitionerDetail.lastName}`
            : ""
      )
      .replace(
        "#location#",
        location === "ANY"
          ? "ANY"
          : locationDetail
            ? `${locationDetail.name}, ${locationDetail.suburb}`
            : ""
      )
      .replace(
        "#Appointment_Start_Time#",
        waitingList.required
          ? `${waitingList.preferredTime} preferred`
          : appointmentDateTime
            ? moment
                .parseZone(appointmentDateTime.startDateTime)
                .format("hh:mma, Do MMM YYYY")
            : ""
      ),
    coordinate: location === "ANY" ? null : positions[location],
    useRecaptcha,
    recaptchaToken,
    isTelehealthAppointment
  };

  const waitingListProps = {
    addToWaitingList: waitingList.required,
    preferredTime: waitingList.preferredTime
  };

  const clientParams = {
    firstName,
    lastName,
    dateOfBirth: formatMoment(moment(dateOfBirth, "DD-MM-YYYY")),
    phoneNumberMobile: mobile,
    email,
    healthFundProviderId: healthFund,
    healthFundMembershipNumber: cardNumber,
    healthFundCardPosition: cardPosition,
    homePostcode: timezone
      ? dataSource.timeZones.find(
          t => t.timezoneUID.toLowerCase() === timezone.toLowerCase()
        ).defaultPostcode
      : null,
    customFields:
      Object.keys(customFields).length === 0
        ? null
        : dataSource.customFields.map(cf => {
            return {
              id: cf.id,
              value: customFields[cf.id] || false,
              name: cf.name
            };
          })
  };

  const params = {
    ...appointmentParams,
    ...waitingListProps,
    clients: [{ ...clientParams }]
  };

  dispatch(loading(true));
  try {
    const { data } = await portalService.submitBooking(params);
    if (!personalDetail.isVerifyDrawerOpen) dispatch(toggleVerifyDrawer(true));

    if (isRequestingCode) {
      const { smsVerifyCode } = data;

      dispatch({
        type: FORM_ACTIONS.STORE_VERIFY_CODE,
        payload: { verifyCode: smsVerifyCode }
      });
    }

    dispatch(loading(false));
  } catch (error) {
    dispatch(
      actions.showError({
        text: getResponseErrorMessage(error),
        canDismiss: true
      })
    );
    dispatch(loading(false));
    throw error;
  }
};



// WEBPACK FOOTER //
// ./src/modules/ContactForm/actions/formActions.js